export default "__VITE_ASSET__BwVVdI86__ 640w, __VITE_ASSET__DiatHrAs__ 1024w";